export default __webpack_public_path__ + "static/media/s2_female.008c8cb4.wav";